module.exports = __webpack_public_path__ + "img/tristana.43dda133.jpg";